/* eslint-disable @dhl/mui/no-hardcoded-colors */
/**
 * this is a temporary file to hold the ppl brand colors.
 * when the DS can be used in this app, this should be removed
 * and the appropriate tenant should be used.
 */

const brandBlue = {
  100: '#80A5C9',
  200: '#6693BE',
  300: '#4D81B3',
  400: '#336FA9',
  500: '#195D9E',
  600: '#004B93',
  700: '#004384',
  800: '#003C76',
  900: '#003467',
}

const brandGold = {
  100: '#FBF7F1',
  200: '#F6EEE3',
  300: '#F2E6D5',
  400: '#EAD6BA',
  500: '#E1C59E',
  600: '#D4AC74', // cartboard
  700: '#CC9D5B',
  800: '#C58E42',
  900: '#AF7D36',
}

const functionalRed = {
  100: '#FBE6E7',
  200: '#F6D4CD',
  300: '#EEAA9B',
  400: '#E57F69',
  500: '#DD5537',
  600: '#D42A05',
  700: '#AA2204',
  800: '#7F1903',
  900: '#551102',
}

const functionalOrange = {
  100: '#FDF0E6',
  200: '#FBDAC0',
  300: '#F6B681',
  400: '#F3A05B',
  500: '#F18A35',
  600: '#E96F26',
  700: '#BE5702',
  800: '#8E4102',
  900: '#5F2C01',
}

const functionalBlue = {
  100: '#E5F2FC',
  200: '#CCE4F9',
  300: '#99C9F2',
  400: '#66AFEC',
  500: '#3394E5',
  600: '#0076D6',
  700: '#0061B2',
  800: '#004986',
  900: '#003059',
}

const functionalGreen = {
  100: '#E5F6ED',
  200: '#CCEEDB',
  300: '#99DCB7',
  400: '#66CB93',
  500: '#33B96F',
  600: '#00A84B',
  700: '#00863C',
  800: '#00652D',
  900: '#00431E',
}

const foundationGrey = {
  100: '#FFFEFE',
  200: '#F2F2F2',
  250: '#F0F0F0',
  300: '#E8E8E8',
  400: '#D0D0D0',
  500: '#B2B2B2',
  600: '#8C8C8C',
  700: '#424242',
  800: '#1C1C1E',
  900: '#030303',
}

const primary = {
  main: brandBlue[600],
  light: brandBlue[100],
  dark: brandBlue[800],
  contrastText: '#FFFFFF',
  notContained: brandBlue[700],
  states: {
    focus: brandBlue[300],
    hover: 'rgba(0, 75, 147, 0.08)',
    selected: 'rgba(0, 75, 147, 0.15)',
  },
}

const secondary = {
  main: brandGold[600],
  light: brandGold[100],
  dark: brandGold[800],
  contrastText: '#030303',
  notContained: brandGold[800],
  states: {
    focus: brandGold[300],
    hover: brandGold[100],
  },
}

const error = {
  main: functionalRed[600],
  light: functionalRed[100],
  dark: functionalRed[700],
  contrastText: '#FFFFFF',
  notContained: functionalRed[700],
  states: {
    focus: functionalRed[300],
    hover: functionalRed[100],
  },
}

const warning = {
  main: functionalOrange[700],
  light: functionalOrange[100],
  dark: functionalOrange[900],
  contrastText: '#FFFFFF',
  notContained: functionalOrange[900],
  states: {
    focus: functionalOrange[400],
    hover: functionalOrange[100],
  },
}

const info = {
  main: functionalBlue[600],
  light: functionalBlue[100],
  dark: functionalBlue[700],
  contrastText: '#FFFFFF',
  notContained: functionalBlue[700],
  states: {
    focus: functionalBlue[300],
    hover: functionalBlue[100],
  },
}

const success = {
  main: functionalGreen[700],
  light: functionalGreen[100],
  dark: functionalGreen[900],
  contrastText: '#FFFFFF',
  notContained: functionalGreen[800],
  states: {
    focus: functionalGreen[300],
    hover: functionalGreen[100],
  },
}

const text = {
  primary: foundationGrey[800],
  secondary: foundationGrey[700],
  disabled: foundationGrey[600],
}

const background = {
  default: foundationGrey[200],
  paper: '#FFFFFF',
}

const action = {
  hover: 'rgba(0, 0, 0, 0.05)',
  focus: 'rgba(0, 0, 0, 0.08)',
  disabled: 'rgba(0, 0, 0, 0.25)',
  disabledBackground: 'rgba(0, 0, 0, 0.05)',
  pressed: 'rgba(0, 0, 0, 0.08)',
}

export const pplPalette = {
  primary,
  secondary,
  error,
  warning,
  info,
  success,
  text,
  background,
  action,

  grey: {
    100: foundationGrey[100],
    200: foundationGrey[200],
    300: foundationGrey[300],
    400: foundationGrey[400],
    500: foundationGrey[500],
    600: foundationGrey[600],
    700: foundationGrey[700],
    800: foundationGrey[800],
    900: foundationGrey[900],
    A100: foundationGrey[100],
    A200: foundationGrey[200],
    A400: foundationGrey[400],
    A700: foundationGrey[700],
  },

  divider: foundationGrey[300],

  static: {
    dark: foundationGrey[900],
    light: '#FFFEFE',
    goGreen: '#006443',
  },

  components: {
    pageHeader: {
      default: primary.main,
      color: {
        contrast: '#000000',
        default: '#FFFFFF',
      },
    },
    navbar: {
      selected: 'rgba(0, 75, 147, 0.10)',
      selectedHover: 'rgba(0, 75, 147, 0.05)',
    },
    avatar: {
      background: '#005BBB',
      border: foundationGrey[400],
    },
    dataGrid: {
      zebraDark: foundationGrey[200],
      hover: 'rgba(0, 0, 0, 0.10)',
    },
    switch: {
      fill: foundationGrey[300],
      border: foundationGrey[400],
    },
    chip: {
      border: foundationGrey[400],
      focus: foundationGrey[900],
    },
  },
}
